<template>
  <div v-if="hasError" class="ui warning message">{{ message }}</div>
</template>

<script>
export default {
    props: {
        form: {
            required: true
        },
        field: {
            required: true,
            type: String
        },
        subField: {
            required: false,
            type: String
        },
        index: {
            required: false,
            type: Number
        }
    },
    computed: {
        hasError: function() {
            if (this.index !== undefined && this.subField) {
                return !!(
                    this.form.$errors &&
                    this.form.$errors[this.field] &&
                    this.form.$errors[this.field][this.index] &&
                    this.form.$errors[this.field][this.index][this.subField]
                );
            }
            return this.form.hasError(this.field);
        },
        message: function() {
            if (this.index !== undefined && this.subField && this.form.hasError(this.field)) {
                return this.form.$errors[this.field][this.index][this.subField][0];
            }
            return this.form.error(this.field);
        }
    }
};
</script>
